/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Loader from '../../../common/Loader';
import {
  getItinerarySupplierFoodReportDetail,
  clearItinerarySupplierFoodReportDetail,
} from '../../../../actions/food/ItinerarySupplierFood';
import ItinerarySupplierFoodReportDetail from './ItinerarySupplierFoodReportDetail';
import Modal from '../../../common/modal/Modal';

const ItinerarySupplierFoodReportDetailButton = ({
  dispatchGetItinerarySupplierFoodReportDetail,
  dispatchClearItinerarySupplierFoodReportDetail,
  itinerarySupplierFoodId,
  itinerarySupplierFood,
  loading,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickOpen = () => {
    setShowModal(true);

    if (itinerarySupplierFoodId) {
      dispatchGetItinerarySupplierFoodReportDetail({ itinerarySupplierFoodId });
    }
  };

  const onClickClose = () => {
    setShowModal(false);
    dispatchClearItinerarySupplierFoodReportDetail();
  };

  useEffect(
    () => () => {
      dispatchClearItinerarySupplierFoodReportDetail();
    },
    [dispatchClearItinerarySupplierFoodReportDetail],
  );

  if (!itinerarySupplierFoodId) return null;

  let body = null;

  if (loading) {
    body = <Loader />;
  } else if (!itinerarySupplierFood) {
    body = <div className="alert alert-info">Sin detalle de alimentación</div>;
  } else {
    body = <ItinerarySupplierFoodReportDetail {...itinerarySupplierFood} />;
  }

  return (
    <>
      <Button color="primary" size="sm" onClick={onClickOpen}>
        Ver detalle
      </Button>

      <Modal
        show={showModal}
        title="Detalle de alimentación"
        body={body}
        onClickClose={onClickClose}
        cancelButtonText="Cerrar"
        onClickCancel={onClickClose}
        size="xl"
      />
    </>
  );
};

ItinerarySupplierFoodReportDetailButton.propTypes = {
  dispatchGetItinerarySupplierFoodReportDetail: PropTypes.func.isRequired,
  dispatchClearItinerarySupplierFoodReportDetail: PropTypes.func.isRequired,
  itinerarySupplierFoodId: PropTypes.number,
  itinerarySupplierFood: PropTypes.shape({
    id: PropTypes.number,
    registeredBus: PropTypes.shape({
      id: PropTypes.number,
      companyBusId: PropTypes.string,
    }),
    originLocationName: PropTypes.string,
    destinationLocationName: PropTypes.string,
    departureDate: PropTypes.number,
    itinerarySupplierFoodDetailList: PropTypes.array,
    driverList: PropTypes.array,
    cabinCrewList: PropTypes.array,
    passengerFlowForItinerary: PropTypes.object,
    actualPassengerFlowForItinerary: PropTypes.object,
  }),
  loading: PropTypes.bool,
};

ItinerarySupplierFoodReportDetailButton.defaultProps = {
  itinerarySupplierFoodId: null,
  itinerarySupplierFood: null,
  loading: false,
};

const mapStateToProps = ({ FoodUnit }) => {
  const detail = FoodUnit.ItinerarySupplierFood.getIn(['report', 'detail']);

  return {
    loading: !FoodUnit.ItinerarySupplierFood.getIn([
      'current',
      'activity',
    ]).isEmpty(),
    itinerarySupplierFood: detail && detail.toJS ? detail.toJS() : detail,
  };
};

const mapDispatchToProps = {
  dispatchGetItinerarySupplierFoodReportDetail:
    getItinerarySupplierFoodReportDetail,
  dispatchClearItinerarySupplierFoodReportDetail:
    clearItinerarySupplierFoodReportDetail,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItinerarySupplierFoodReportDetailButton);
